//@flow
export const MarkerType = {
    HOVERABLE: 'HOVERABLE',
    NON_HOVERABLE: 'NON_HOVERABLE'
};

export const FitToBoundStrategyEnum = {
    NEXT_RENDER: 'NEXT_RENDER',
    ONBOUNDS_CHANGE: 'ONBOUNDS_CHANGE'
};

export type FitToBoundStrategyType = $Values<typeof FitToBoundStrategyEnum>;

export const PolygonTypeEnum = {
    NORMAL: 'NORMAL',
    CONVEX_HULL: 'CONVEX_HULL'
};

export const MarkerTypeEnum = Object.freeze({
    Numbered: 'NUMBERED',
    Dot: 'DOT'
});

export const ClusterTypeEnum = Object.freeze({
    AllTasks: 'ALL_TASKS',
    OldPlanTasks: 'OLD_PLAN_TASKS'
});

export const TourClusterTypeEnum = Object.freeze({
    AllTours: 'ALL_TOURS',
    VisibleTours: 'VISIBLE_TOURS'
});

export const ZONE_FILTER_ID = 'ZONES';

export default null;
